import React from "react";
import { lazy } from "react";

import { RouteObject } from "react-router-dom";

import AppLayout from "../modules/layout/AppLayout";
import ProtectedRoute from "./ProtectedRoute";
import AdminRoute from "./AdminRoute";
import UserRoute from "./UserRoute";
import AuthCallback from "../auth/AuthCallback";
import DetailedServiceProfilePage from "@/pages/services/DetailedServiceProfilePage";
import UserDashboard from "../modules/Dashboard/UserDashboard";
import AdminDashboard from "../modules/Dashboard/AdminDashboard";
import ServiceRequestDetails from "@/modules/service_request_manage/ServiceRequestDetails";
import AdminOrderEdit from "@/modules/order/admin/pages/AdminOrderEdit";
import AdminOrderView from "@/modules/order/admin/pages/AdminOrderView";
import UserOrderView from "@/modules/order/new_order/pages/UserOrderView";
import OrderCreate from "@/modules/order/new_order/pages/OrderCreate";
import OrderPaymentViewPage from "@/modules/order/common/OrderPaymentViewPage";
import OrderTaxInvoiceReceiptPage from "@/modules/order/common/OrderTaxInvoiceReceiptPage";
import PaymentTransactionsPage from "@/modules/order/admin/pages/PaymentTransactionsPage";

/* pages */
const LandingPage = lazy(() => import("../pages/LandingPage"));
const CareerPage = lazy(() => import("@/pages/services/CareerPage"));
const AcademicPage = lazy(() => import("@/pages/services/AcademicPage"));
const CorporatePage = lazy(() => import("@/pages/services/CorporatePage"));
const MyPayments = lazy(() => import("@/modules/payment/MyPayments"));
const ReviewOrder = lazy(() => import("@/modules/payment/ReviewOrder"));
const SECreate = lazy(() => import("@/modules/service_requests/self_evaluation/SECreate"));
const SEEdit = lazy(() => import("@/modules/service_requests/self_evaluation/SEEdit"));
const UnderConstruction = lazy(() => import("@/modules/common/UnderConstruction"));
const CancelRequest = lazy(() => import("@/components/mock_interview/SE_CancelWrapper"));
const UserProfilePage = lazy(() => import("@/modules/profile/UserProfilePage"));
const UserProfileView = lazy(() => import("@/modules/user_profile/view/UserProfileView"));
const UserProfileEditor = lazy(() => import("@/modules/user_profile/edit/UserProfileEditor"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <AppLayout />,
    children: [
      /* =========================================================
         PUBLIC
      ========================================================= */

      { index: true, element: <LandingPage /> },

      { path: "careerdevsvc", element: <CareerPage /> },
      { path: "academicsvc", element: <AcademicPage /> },
      { path: "corporatesvc", element: <CorporatePage /> },

      { path: "authorize/callback", element: <AuthCallback /> },

      /* =========================================================
         AUTHENTICATED
      ========================================================= */

      {
        element: <ProtectedRoute />,
        children: [
          /* ---------------- USER ---------------- */

          {
            element: <UserRoute />,
            children: [
              /* =====================================================
                 USER HOME / SERVICE AREA
              ===================================================== */

              {
                path: "home",
                children: [
                  {
                    index: true,
                    element: <DetailedServiceProfilePage />,
                  },

                  // {
                  //   path: ":serviceGroup",
                  //   element: <DetailedServiceProfilePage />,
                  // },

                  // {
                  //   path: ":serviceGroup/:shortname",
                  //   element: <DetailedServiceProfilePage />,
                  // },

                  /* =====================================================
                     USER ORDERS
                  ===================================================== */

                  {
                    path: "orders",
                    element: <UserDashboard />,
                    children: [
                      {
                        index: true,
                        element: <UserOrderView />,
                      },

                      {
                        path: "new/:direct?",
                        element: <OrderCreate />,
                      },
                      {
                        path: "orders/:orderId/payments",
                        element: <PaymentTransactionsPage />,
                      },
                      {
                        path: "invoice/:orderId",
                        element: <OrderPaymentViewPage />,
                      },
                      {
                        path: "receipt/:orderId",
                        element: <OrderTaxInvoiceReceiptPage />,
                      },
                    ],
                  },

                  /* =====================================================
                     PROFILE
                  ===================================================== */

                  {
                    path: "profile",
                    element: <UserProfilePage />,
                    children: [
                      {
                        index: true,
                        element: <UserProfileView />,
                      },
                      {
                        path: "view",
                        element: <UserProfileView />,
                      },
                      {
                        path: "edit",
                        element: <UserProfileEditor />,
                      },
                    ],
                  },

                  /* =====================================================
                     SERVICE REQUESTS
                  ===================================================== */

                  {
                    path: "request/:requestId",
                    element: <ServiceRequestDetails />,
                  },

                  {
                    path: "edit/:requestId",
                    element: <SEEdit />,
                  },

                  {
                    path: "cancel/:requestId",
                    element: <CancelRequest />,
                  },
                ],
              },
            ],
          },

          /* ---------------- SHARED ---------------- */

          {
            path: "service-requests",
            children: [
              // Create Request
              {
                path: "create/self-evaluation",
                element: <SECreate />,
              },
              {
                path: "create/internship",
                element: (
                  <UnderConstruction title="Applied Internship" />
                ),
              },
              {
                path: "create/fpp",
                element: (
                  <UnderConstruction title="FPP Service" />
                ),
              },
              {
                path: "create/job-readiness",
                element: (
                  <UnderConstruction title="JRA Program" />
                ),
              },
              {
                path: "create/iaas",
                element: (
                  <UnderConstruction title="Interview As A Service" />
                ),
              },
              {
                path: "create/ws",
                element: (
                  <UnderConstruction title="Workshop" />
                ),
              },

              // Edit Existing Request
              // {
              //   path: "edit/:serviceId/:formId/:requestId",
              //   element: <ServiceRequestEdit />,
              // },

              // View Existing Request
              {
                path: ":requestId",
                element: <ServiceRequestDetails />,
              },

              // Review & Payment
              {
                path: "order/:requestId",
                element: <ReviewOrder />,
              },
            ],
          },

          {
            path: "payments",
            element: <MyPayments />,
          },

          /* ---------------- ADMIN ---------------- */

{
  element: <AdminRoute />,
  children: [
    {
      path: "admin",
      element: <AdminDashboard />,
      children: [
        {
          index: true,
          element: <AdminOrderView />,
        },
                  /* =====================================================
                     PROFILE
                  ===================================================== */

                  {
                    path: "profile",
                    element: <UserProfilePage />,
                    children: [
                      {
                        index: true,
                        element: <UserProfileView />,
                      },
                      {
                        path: "view",
                        element: <UserProfileView />,
                      },
                      {
                        path: "edit",
                        element: <UserProfileEditor />,
                      },
                    ],
                  },

        {
          path: "orders/new",
          element: <OrderCreate />,
        },

        {
          path: "orders/edit/:orderId",
          element: <AdminOrderEdit />,
        },

        {
          path: "orders/:orderId/payments",
          element: <PaymentTransactionsPage />,
        },

        {
          path: "orders/invoice/:orderId",
          element: <OrderPaymentViewPage />,
        },
      ],
      
    },

    {
      path: "admin/edit/:requestId",
      element: <SEEdit />,
    },
  ],
}
        ],
      },
    ],
  },
];

export default routes;